import React, { useContext } from 'react';
import { Button, Space } from 'antd';
import { ApplicationUIContext, Form, Table, useDrawerState } from 'ui-library';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';

import { Operands, Operators, ValueAddonAfter, YuhuModules } from '../Form/constants';
import RuleDrawer from './../Form/RuleDrawer';

const RulesTableRowActions = ({ onUpdate, onDelete, record }) => {
  const [, editRuleDrawer] = useDrawerState(false);

  return (
    <>
      <Space size="middle">
        <Button type="link" icon={<EditOutlined />} onClick={editRuleDrawer.open} />
        <Button type="link" icon={<DeleteOutlined />} onClick={onDelete} />
      </Space>

      <RuleDrawer
        mode="edit"
        drawer={editRuleDrawer}
        initialValues={{
          ...record,
        }}
        addRule={onUpdate}
      />
    </>
  );
};

const RulesTable = ({ rules, operations }) => {
  const { isMobile } = useContext(ApplicationUIContext);
  const rulesForm = Form.useFormInstance();

  const columns = [
    {
      title: 'Yuhu Module',
      dataIndex: 'yuhu_module',
      key: 'yuhu_module',
      render: (_, row) => {
        return (
          <Form.Item shouldUpdate>
            {({ getFieldValue }) => {
              return YuhuModules[getFieldValue(['rules', row.name, 'yuhu_module'])];
            }}
          </Form.Item>
        );
      },
    },
    {
      title: 'Trigger',
      dataIndex: 'operand',
      render: (_, row) => {
        return (
          <Form.Item shouldUpdate>
            {({ getFieldValue }) => {
              return Operands[getFieldValue(['rules', row.name, 'operand'])];
            }}
          </Form.Item>
        );
      },
    },
    {
      title: 'Operator',
      dataIndex: 'operator',
      render: (_, row) => {
        return (
          <Form.Item shouldUpdate>
            {({ getFieldValue }) => {
              return Operators[getFieldValue(['rules', row.name, 'operator'])];
            }}
          </Form.Item>
        );
      },
    },
    {
      title: 'Value',
      dataIndex: 'value',
      render: (_, row) => {
        return (
          <Form.Item shouldUpdate>
            {({ getFieldValue }) => {
              const value = getFieldValue(['rules', row.name, 'value']);
              if (!value) return '';

              const operand = getFieldValue(['rules', row.name, 'operand']);
              return `${value}${ValueAddonAfter[operand]}`;
            }}
          </Form.Item>
        );
      },
    },
    {
      title: 'Actions',
      dataIndex: 'actions',
      render: (_, record, index) => (
        <RulesTableRowActions
          onUpdate={(updatedRecord) => {
            operations.remove(record.name);
            operations.add(updatedRecord);
          }}
          onDelete={() => operations.remove(record.name)}
          record={rulesForm.getFieldValue('rules')[index]}
        />
      ),
    },
  ];

  return (
    <Table
      dataSource={rules}
      columns={columns}
      hideActionAndSearch
      size={isMobile ? 'middle' : 'small'}
      scroll={{ x: isMobile }}
    />
  );
};

export default RulesTable;
